import request from '@/services/request';

export const create = data => request.post('goals', data);

export const update = (id, payload) => request.put(`goals/${id}`, payload);

export const loadGoals = pagination => request.get('goals', { params: pagination });

export const archive = id => request.patch(`goals/${id}/archive`);

export const pause = id => request.patch(`goals/${id}/pause`);
export const resume = id => request.patch(`goals/${id}/resume`);
export const reset = id => request.patch(`goals/${id}/reset`);

export const makePrivate = id => request.patch(`goals/${id}/private`);
export const makePublic = id => request.patch(`goals/${id}/public`);
